import React from 'react'

import ListLoading from '../../Loaders/ListLoading'

type SelectLoadingProps = {
  initialLoading?: boolean
}

const SelectLoading = ({
  initialLoading,
}: SelectLoadingProps): React.JSX.Element => {
  return (
    <ListLoading
      customHeight='32px'
      {...(initialLoading ? { numberOfRows: 5 } : {})}
    />
  )
}

export default SelectLoading
